$(document).ready(function () {
  // Filter section accordion toggle
  $("body").on("click", ".facets__summary", function () {
    $(this).closest(".js-filter").find(".facet-filter-list").slideToggle();
  });

  $("body").on("click", "li.facets__item label", function () {
    // Navigation handled by change event on checkbox below
  });

  $(document).on("click", ".c__filters-button", function() {
    $(this).closest(".facets-container").find(".facets").addClass("active");
  });

  $("body").on("click", ".facets__form-close", function (e) {
    e.preventDefault();
    $(this).closest(".facets-container").find(".facets").removeClass("active");
  });

  // AJAX filter using Shopify's built-in filter URLs (data-url on each label)
  function applyFilter(filterUrl) {
    // Preserve current sort_by when navigating via filter checkboxes/pills
    var currentSort = new URLSearchParams(window.location.search).get('sort_by');
    if (currentSort) {
      var parsed = new URL(filterUrl, window.location.href);
      if (!parsed.searchParams.has('sort_by')) {
        parsed.searchParams.set('sort_by', currentSort);
        filterUrl = parsed.pathname + parsed.search;
      }
    }

    var gridProductEl = document.getElementById('product-grid');
    var sectionId = gridProductEl ? gridProductEl.dataset.id : null;
    if (!sectionId) { window.location.href = filterUrl; return; }

    var sep = filterUrl.indexOf('?') === -1 ? '?' : '&';
    var sectionUrl = filterUrl + sep + 'section_id=' + sectionId;

    var gridEl = document.getElementById('ProductGridContainer');
    if (gridEl) {
      var loadingEl = gridEl.querySelector('.collection');
      if (loadingEl) loadingEl.classList.add('loading');
    }

    fetch(sectionUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = doc.getElementById('ProductGridContainer');
        if (newGrid && gridEl) gridEl.innerHTML = newGrid.innerHTML;

        var newFilters = doc.querySelector('.facets__form-filter-list');
        var currFilters = document.querySelector('.facets__form-filter-list');
        if (newFilters && currFilters) currFilters.innerHTML = newFilters.innerHTML;

        var newActive = doc.querySelector('.active-facets-mobile');
        var currActive = document.querySelector('.active-facets-mobile');
        if (newActive && currActive) currActive.innerHTML = newActive.innerHTML;

        history.pushState(null, '', filterUrl);
      })
      .catch(function(err) {
        console.error('Filter error:', err);
        window.location.href = filterUrl;
      });
  }

  window.applyCollectionFilter = applyFilter;

  // Checkbox filter — fires after checkbox state has already changed
  $("body").on("change", "#FacetFiltersForm input[type='checkbox']", function() {
    var url = $(this).closest('label').attr('data-url');
    if (url) applyFilter(url);
  });

  // Sort dropdown
  $("body").on("change", "#SortBy", function() {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    applyFilter(url.pathname + url.search);
  });

  // Active filter pill removal (AJAX instead of full page nav)
  $("body").on("click", ".active-facets__button, .active-facets__button-remove", function(e) {
    var $link = $(this).is('a') ? $(this) : $(this).closest('a');
    var href = $link.attr('href');
    if (href && href !== '#') {
      e.preventDefault();
      applyFilter(href);
    }
  });
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.querySelector('.js-price-filter-apply').addEventListener('click', this.onRangeClick.bind(this));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onRangeClick(event) {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    const minName = minInput.getAttribute('name');
    const maxName = maxInput.getAttribute('name');

    const url = new URL(window.location.href);
    if (minInput.value) url.searchParams.set(minName, minInput.value);
    else url.searchParams.delete(minName);
    if (maxInput.value) url.searchParams.set(maxName, maxInput.value);
    else url.searchParams.delete(maxName);

    const filterUrl = url.pathname + url.search;
    if (window.applyCollectionFilter) window.applyCollectionFilter(filterUrl);
    else window.location.href = filterUrl;
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

// Holder det sticky filter lige under den sticky header
(function () {
  var header = document.querySelector('.shopify-section-header-sticky, [id$="__header"], #shopify-section-header');
  if (!header) return;
  var ticking = false;
  function setOffset() {
    var bottom = Math.max(0, header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--sticky-filter-top', bottom + 'px');
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(setOffset); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setOffset();
})();